import React from 'react'
import ProductcartUx from '../ProductcartUx'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules';
import { Pagination } from 'swiper/modules';

function ProductosInteres({ swiperRef, ProdComplementarios, product }) {



  return (
    <section className="mt-16 mb-16 px-[21px] md:px-[68px]" >
      <div className="w-full flex flex-col items-center   gap-2 ">
        <div
          className="w-full h-12 mb-2 text-center justify-center text-[#4B2907] text-[21px] md:text-4xl font-bold font-plus_jakarta "
        >
          Productos que te puedan interesar
        </div>

        <span
          className="w-full h-fit md:h-9  text-center justify-center text-[#454545] text-[16px] md:text-2xl font-light font-plus_jakarta"
        >
          Opciones diseñadas para sorprender, regala emociones que nunca se olvidan
        </span>
        <div
          className='md:hidden'
        >
          <Swiper
            ref={swiperRef}
            className="img-complementarias w-[calc(100vw-54px)] h-full mt-2"
            spaceBetween={5}
            loop={false}
            centeredSlides={false}
            initialSlide={0}
            allowTouchMove={true}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            autoplay={{
              delay: 5500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 2,   // Pantallas muy pequeñas
                centeredSlides: false,
                loop: true,
              },
              640: {
                slidesPerView: 3,   // Pantallas pequeñas
              },
              768: {
                slidesPerView: 3,
                delay: 5500,
                disableOnInteraction: true,
                pauseOnMouseEnter: true, // Tablets
              },
              1024: {
                slidesPerView: 3,
                delay: 5500,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,    // Laptops
              },
              1280: {
                slidesPerView: 5,
                delay: 5500,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
                // Desktops grandes (Swiper toma 5 columnas)
              },
            }}
            style={{ zIndex: 0 }}
          >


            {ProdComplementarios
              /* .sort((a, b) => {
                if (a.id === selectedItem) return -1;
                if (b.id === selectedItem) return 1;
                return 0;
              }) */

              .map((complemento, index) => (
                <SwiperSlide key={index} className='self-start' id='SwiperPrincipio'>
                  <ProductcartUx item={complemento} />

                </SwiperSlide>
              ))}
          </Swiper>
        </div>

        <div className="md:grid grid-cols-1 mt-[42px] sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 hidden ">

          {ProdComplementarios.length > 0 && ProdComplementarios.map((item, index) => (

            <ProductcartUx key={`product-${index}`} item={item} />
          ))}

        </div>

        <div className="mt-9 w-60 h-14 p-2.5 bg-[#FF8555] rounded-[10px] inline-flex justify-center items-center gap-2.5">
          <a
            href={`/catalogo${product?.categories_many[0]?.slug ? `/${product.categories_many[0].slug}` : ''}`}
            className="justify-center text-white text-lg font-bold font-plus_jakarta ">Ver más productos</a>
        </div>

      </div>

    </section>
  )
}

export default ProductosInteres